import { Card, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';

const TopCardsData = ({ img, subtitle, title, subtitleColor }) => {
  return (
    <Card>
      <span className="lstick bg-info top-card"></span>
      <CardBody>
        <div className="d-flex align-items-center">
          <img src={img} alt="icon" />
          <div className="ms-3">
            
            {/* Subtitle with dynamic color */}
            <h6
              className="mt-2 mb-0"
              style={{
                color: subtitleColor || "#6c757d", // default muted gray
                fontWeight: 500,
              }}
            >
              {subtitle}
            </h6>

            {/* Title (date or number) */}
            <h2 className="mt-0">{title}</h2>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

TopCardsData.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  img: PropTypes.string,
  subtitle: PropTypes.string,
  subtitleColor: PropTypes.string,
};

export default TopCardsData;
